import React from 'react';
import Gstr2bReconciliation from '../GSTR2B_reconciliation/Gstr2bReconciliation';

const Gstr8aReconciliation = () => {
  return (
    <div>
      <Gstr2bReconciliation isGstr8A={true}/>
    </div>
  );
};

export default Gstr8aReconciliation;
